import React from 'react'

const AnnouncementsList = () => {
  return (
    <div>AnnouncementsList</div>
  )
}

export default AnnouncementsList